import { useQuery } from '@tanstack/react-query';
import { searchCareProviders } from '../services/users';

const useSearchCareProviders = (name = "") => {
    const searchCareProvidersQuery = useQuery({
        queryKey: ['searchCareProviders', name],
        queryFn: () => searchCareProviders(name),
        enabled: Boolean(name.trim().length > 0)
    });
    return searchCareProvidersQuery;
}

export default useSearchCareProviders; 